import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './RENT_Property_Management_Agreement_S.css';

const RENT_Property_Management_Agreement_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Property Management Agreement');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_PROPERTY_MANAGEMENT_AGREEMENT/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/RENT_Property_Management_Agreement', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_PROPERTY_MANAGEMENT_AGREEMENT/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/RENT_Property_Management_Agreement',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Property_Management_Agreement',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [RENT_PROPERTY_MANAGEMENT_AGREEMENT, setRENT_PROPERTY_MANAGEMENT_AGREEMENT] = React.useState(null);
  const [RENT_PROPERTY_MANAGEMENT_AGREEMENT_S, setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S] = React.useState(null);

  var Ids = [];
  for(var Ele in RENT_PROPERTY_MANAGEMENT_AGREEMENT_S){
	  for(var Sec in RENT_PROPERTY_MANAGEMENT_AGREEMENT_S[Ele]){
			if(Sec == "id")
				Ids.push(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S[Ele]["status"]);
			else if(Array.isArray(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S[Ele][Sec]))
				  for(var Row in RENT_PROPERTY_MANAGEMENT_AGREEMENT_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in RENT_PROPERTY_MANAGEMENT_AGREEMENT_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_PROPERTY_MANAGEMENT_AGREEMENT`).then((response) => {
      setRENT_PROPERTY_MANAGEMENT_AGREEMENT(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!RENT_PROPERTY_MANAGEMENT_AGREEMENT_S) return <div>Loading...</div>;

 const handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S = async (data) => {
  };




  const handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_PROPERTY_MANAGEMENT_AGREEMENT_S', JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_PROPERTY_MANAGEMENT_AGREEMENT_S');
      setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["1"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_0"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("1","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_0",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["1"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_1"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("1","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_1",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["1"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_2"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("1","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_2",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_0"]=value;
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_0",value,Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
  }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_1"]=value;
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_1",value,Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
  }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_2"]=value;
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_2",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT']);
  }; 
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_3"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_3",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_4"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_4",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["3"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_0"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("3","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_0",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["3"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_1"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("3","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_1",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT));
	Temp_Data["3"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_2"]=value;
	Form_Data_onChange("3","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_2",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT']);
  }; 
  


const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT));
	Temp_Data["4"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_0"]=value;
	Form_Data_onChange("4","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_0",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT']);
  }; 
  

  
      
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["4"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1"]=value ? true : false; // optionally just use boolean
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("4","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  


  
      
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["4"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2"]=value ? true : false; // optionally just use boolean
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("4","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  


    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["5"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_5_0"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("5","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_5_0",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT));
	Temp_Data["6"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_0"]=value;
	Form_Data_onChange("6","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_0",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT']);
  }; 
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["6"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_1"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("6","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_1",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["6"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_2"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("6","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_2",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_0",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data);
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT']);
  }; 
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_1"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_1",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_2"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_2",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_3"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_3",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_PROPERTY_MANAGEMENT_AGREEMENT_S));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_4"]=value;
	//handleAddRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data,App_Data['RENT_PROPERTY_MANAGEMENT_AGREEMENT_S']);
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_4",value,Temp_Data);
 	//handleLastDataRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
    setRENT_PROPERTY_MANAGEMENT_AGREEMENT_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = RENT_PROPERTY_MANAGEMENT_AGREEMENT_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Rental Income Property Management Agreement')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT PM Agreement ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_0" type="text" className="form-control" placeholder="RENT PM Agreement ID"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT PM Agreement ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_1" type="text" className="form-control" placeholder="Asset ID"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Property Manager Stakeholder ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_2" type="text" className="form-control" placeholder="Property Manager Stakeholder ID"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Property Manager Stakeholder ID`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Agreement Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_0" type="date"   
							onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_0_Change} style={{ borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Agreement Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Agreement End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_1" type="date"   
							onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_1_Change} style={{ borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Agreement End Date
					  </div>
				  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Management Fee Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_2"   onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_2_Change} className="form-control" name="Management Fee Type"  >
						  <option value="Percentage of Collected Rent">Percentage of Collected Rent</option>
						  <option value="Flat Monthly Fee">Flat Monthly Fee</option>
						  <option value="Hybrid">Hybrid</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Management Fee Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Management Fee Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_3" type="text" className="form-control" placeholder="Management Fee Percentage"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Management Fee Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Flat Management Fee USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_4" type="text" className="form-control" placeholder="Flat Management Fee USD"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Flat Management Fee USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '2000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Leasing Fee Terms`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_0" type="text" className="form-control" placeholder="Leasing Fee Terms"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '2000ch' }}>
						 {t(`Enter Leasing Fee Terms`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Maintenance Approval Limit USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_1" type="text" className="form-control" placeholder="Maintenance Approval Limit USD"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Maintenance Approval Limit USD`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Rent Collection Responsibility`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_2"   onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_2_Change} className="form-control" name="Rent Collection Responsibility"  >
						  <option value="Property Manager">Property Manager</option>
						  <option value="Platform Escrow">Platform Escrow</option>
						  <option value="Owner">Owner</option>
						  <option value="Third-Party Servicer">Third-Party Servicer</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Rent Collection Responsibility
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Reporting Frequency`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_0"   onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_0_Change} className="form-control" name="Reporting Frequency"  >
						  <option value="Monthly">Monthly</option>
						  <option value="Quarterly">Quarterly</option>
						  <option value="Semi-Annual">Semi-Annual</option>
						  <option value="Annual">Annual</option>
						  <option value="Event Based">Event Based</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Reporting Frequency
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Bank Statement Required`)} <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1_Change} 
					  checked={RENT_PROPERTY_MANAGEMENT_AGREEMENT_S?.["4"]?.["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1"] === "true" || RENT_PROPERTY_MANAGEMENT_AGREEMENT_S?.["4"]?.["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Investor Report Required`)} <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2_Change} 
					  checked={RENT_PROPERTY_MANAGEMENT_AGREEMENT_S?.["4"]?.["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2"] === "true" || RENT_PROPERTY_MANAGEMENT_AGREEMENT_S?.["4"]?.["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Agreement Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_5_0" type="text" className="form-control" placeholder="Agreement Document Link"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Agreement Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Agreement Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_0"   onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_0_Change} className="form-control" name="Agreement Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Active">Active</option>
						  <option value="Expired">Expired</option>
						  <option value="Terminated">Terminated</option>
						  <option value="Rejected">Rejected</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Agreement Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_1" type="text" className="form-control" placeholder="Approved By"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Approved By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_2" type="text" className="form-control" placeholder="Approved At"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Approved At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_0"   onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`RENT PM Agreement ID`)}</th>
                        <th>{t(`Asset ID`)}</th>
                        <th>{t(`Property Manager Stakeholder ID`)}</th>
                        <th>{t(`Agreement Start Date`)}</th>
                        <th>{t(`Agreement End Date`)}</th>
                        <th>{t(`Management Fee Type`)}</th>
                        <th>{t(`Management Fee Percentage`)}</th>
                        <th>{t(`Flat Management Fee USD`)}</th>
                        <th>{t(`Leasing Fee Terms`)}</th>
                        <th>{t(`Maintenance Approval Limit USD`)}</th>
                        <th>{t(`Rent Collection Responsibility`)}</th>
                        <th>{t(`Reporting Frequency`)}</th>
                        <th>{t(`Bank Statement Required`)}</th>
                        <th>{t(`Investor Report Required`)}</th>
                        <th>{t(`Agreement Document Link`)}</th>
                        <th>{t(`Agreement Status`)}</th>
                        <th>{t(`Approved By`)}</th>
                        <th>{t(`Approved At`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {RENT_PROPERTY_MANAGEMENT_AGREEMENT_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_0"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_1"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_1_2"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_0"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_1"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_2"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_3"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_2_4"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_0"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_1"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_3_2"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_0"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_1"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_4_2"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_5_0"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_0"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_1"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_6_2"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_0"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_1"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_2"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_3"]} </td>
						<td>{e["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_PROPERTY_MANAGEMENT_AGREEMENT_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default RENT_Property_Management_Agreement_S;  